export default {
  model () {
    return {
      fiscalName: '',
      rfc: '',
      address: '',
      zip_code: '',
      municipality: '',
      state: '',
      country: '',
      email: '',
      phone: ''
    }
  },
  rules: {
    fiscalName: {type: 'string'},
    rfc: [
      {message: 'El RFC solo acepta mayúsculas y números.', trigger: 'change'},
      {
        type: 'string',
        message: 'El RFC es incorrecto, acepta solo mayúsculas y números.',
        pattern: /^[A-ZÑ&]{3,4}\d{6}(?:[A-Z\d]{3})?$/,
        trigger: 'blur'
      }
    ],
    address: {
      tyoe: 'string',
      message: 'La dirección esta mal escrita o contiene caracteres no validos',
      trigger: 'change'
    },
    zip_code: {tyoe: 'number', message: 'El códig postal, solo acepta números.', trigger: 'change'},
    municipality: {tyoe: 'string', message: 'El RFC solo acepta mayúsculas y números.', trigger: 'change'},
    state: {tyoe: 'string', message: 'El estado esta mal escrito o contiene caracteres no validos', trigger: 'change'},
    country: {tyoe: 'string', message: 'El país esta mal escrito o contiene caracteres no validos', trigger: 'change'},
    email: [
      {message: 'El correo electrónico es requerido', trigger: 'blur'},
      {type: 'email', message: 'Ingrese una dirección de correo correcta', trigger: 'blur'}
    ],
    phone: {type: 'number', message: 'El telefono es incorrecto', trigger: 'blur'}
  }
}



// WEBPACK FOOTER //
// ./src/models/add-new-address-invoice.model.js